const Empty = ({ children }) => {
    return (
        <p className={"text-textGrey text-center border border-dashed border-borderGrey p-8 rounded-lg"}>{children}</p>
    )
}

export default Empty